<!--
 * @Description: 申请 待处理
 * @Author: peifu
 * @Date: 2022-12-21 10:29:14
 * @LastEditors: PF
 * @LastEditTime: 2023-06-15 10:50:41
-->
<template>
  <div>
    <el-dialog class="wp75 hp75" :model-value="isShenQingDaiChuLiHome" :title="title" :before-close="handleClose" :close-on-click-modal="false" destroy-on-close>
      <el-table :data="tableData" border v-loading="loading" height="100%">
        <el-table-column type="index" label="序号" align="center" width="80" />
        <el-table-column prop="bdmc" label="审批表单名称" align="center" show-overflow-tooltip>
          <template #default="scope">
            <el-link v-if="scope.row.zt === 0" type="primary" @click="caoGaoClick(scope.row)">{{scope.row.bdmc}}</el-link>
            <el-link v-else type="primary" @click="chaKanClick(scope.row)">{{scope.row.bdmc}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="sqrxm" label="申请人姓名" align="center" show-overflow-tooltip />
        <el-table-column prop="sqrjgmcs" label="申请人机构名称" align="center" show-overflow-tooltip />
        <el-table-column prop="sqsj" label="申请时间" align="center" show-overflow-tooltip />
        <!-- 0-草稿，1-流转中，9-已通过，10-已驳回 -->
        <el-table-column prop="zt" label="申请状态" align="center" show-overflow-tooltip >
          <template #default="scope">
            <span v-for="(item, index) in clztData.list" :key="index">
              <span v-if="scope.row.zt === item.value">{{item.name}}</span>
            </span>
            <!-- <span v-if="scope.row.zt === 0">草稿</span>
            <span v-if="scope.row.zt === 1" style="color:#E6A23C">流转中</span>
            <span v-if="scope.row.zt === 9" style="color:#67C23A">通过</span>
            <span v-if="scope.row.zt === 10" style="color:#F56C6C">拒绝</span> -->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <shenqingbianjihome v-if="isShenQingBianJiHome" v-model:isShenQingBianJiHome="isShenQingBianJiHome" :shenQingBianJiHomeObj="shenQingBianJiHomeObj" @ReturnData="ReturnData" />
    <detail v-if="isXiangQing" v-model:isXiangQing="isXiangQing" :xiangQingObj="xiangQingObj" @xiangQingReturn="handleClose" />
  </div>
</template>

<script setup>
import { defineProps, watch, defineEmits, ref } from 'vue'
import { shenqingshenpilist } from '@/api/home.js'
import { loadSelect } from '@/api/common.js'
import shenqingbianjihome from './edit.vue'
import detail from './detail.vue'
const props = defineProps({
  isShenQingDaiChuLiHome: {
    type: Boolean,
    required: true
  },
  shenQingDaiChuLiHomeObj: {
    type: Object,
    required: false
  }
})
const loading = ref(false)
const title = ref('')
const tableData = ref([])
const clztData = ref([])

// 编辑 弹窗
const isShenQingBianJiHome = ref(false)
const shenQingBianJiHomeObj = ref()
// 详情 抽屉
const isXiangQing = ref(false)
const xiangQingObj = ref()

const emits = defineEmits(['update:isShenQingDaiChuLiHome'])

// 草稿
const caoGaoClick = (item) => {
  isShenQingBianJiHome.value = true
  shenQingBianJiHomeObj.value = {
    type: 1, // [1]发起审批 [2]查看数据
    id: item.id,
    bdmc: item.bdmc
  }
}
// 详情
const chaKanClick = (item) => {
  isXiangQing.value = true
  xiangQingObj.value = {
    id: item.id,
    title: '详情',
    type: 'daiChuLi'
  }
}

const ReturnData = () => {
  isShenQingBianJiHome.value = false
  initList()
}
// 关闭
const handleClose = () => {
  emits('update:isShenQingDaiChuLiHome', false)
}
// 查询我申请的审批数组
const initList = () => {
  loading.value = true
  const info = {
    clzt: 1 // 处理状态：1-未处理，2-已处理
  }
  shenqingshenpilist(info).then(res => {
    tableData.value = res.data
    loading.value = false
  })
}
watch(
  () => props.isShenQingDaiChuLiHome,
  () => {
    if (props.isShenQingDaiChuLiHome) {
      title.value = props.shenQingDaiChuLiHomeObj.title || ''
      loadSelect({ url: '/api/v2/bangong/bangongshenpishenqing/shenpishenqingzhuangtai', data: clztData })
      initList()
    }
  },
  { deep: true, immediate: true }
)
</script>
